const buttonListener = (button: HTMLButtonElement) => {
  button.addEventListener("click", () => {
    const url = new URL(window.top.location.href);

    url.searchParams.set("variant", button.dataset.variantId || "");

    window.top.location.href = url.toString();
  });
};

const selectListener = (select: HTMLSelectElement) => {
  select.addEventListener("change", () => {
    const selectedOption = select.options[select.selectedIndex];
    const variantId = selectedOption?.dataset.variantId;

    if (!variantId) {
      return;
    }

    const url = new URL(window.top.location.href);

    url.searchParams.set("variant", variantId);

    window.top.location.href = url.toString();
  });
};

const init = () => {
  const optionInputWrappers = document.querySelectorAll(
    "[data-option-buttons]"
  );

  if (!optionInputWrappers) {
    console.log("Option input wrappers not found");
    return;
  }
  optionInputWrappers.forEach((optionInputWrapper) => {
    const buttons = optionInputWrapper.querySelectorAll(
      "[dynamic-variant-button]"
    );
    buttons.forEach((button) => buttonListener(button as HTMLButtonElement));
  });

  const variantSelects =
    document.querySelectorAll<HTMLSelectElement>("[data-variant-select]");

  variantSelects.forEach((select) => selectListener(select));
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", init)
  : init();
